export default "__VITE_ASSET__DXcmhM6O__"